module.exports = __webpack_public_path__ + "img/present-employee.37363247.png";